import { Link } from "react-router-dom";
import HeaderNav from "../../../../../layout/HeaderNav";

export default function Header() {
    return (
        <header className="header">
            <div className="headerLogoSection">
                <p className="backArrow"><Link to="/drills/ligningsmester">←</Link></p>
                <div>
                    <img
                        src="/images/ligningsmester_1.png"
                        alt="Ligningsmester_1"
                        className="h-12 w-12 rounded-lg"
                    />
                </div>
                
                <div className="headerTitle">
                    <h3>kapitel 1</h3>
                    <h2>ligningsmester</h2>
                </div>
            </div>

            <HeaderNav />
        </header>
    )
}